import { Button, Drawer } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import type { PropsWithChildren } from 'react';

type Props = {
  opened: boolean;
  onClose: () => void;
  onRemoveFilter: () => void;
};

// The Mantine-drawer replacement for the legacy FiltersSideMenu (sideMenuShow).
// Wraps the filter form and exposes the same "remove all filters" action; the
// shared FiltersSideMenu stays in place for the legacy CustomTable.
export function FiltersDrawer({
  opened,
  onClose,
  onRemoveFilter,
  children,
}: PropsWithChildren<Props>) {
  const { t } = useTranslation();

  return (
    <Drawer position="right" opened={opened} onClose={onClose} title={t(i18nKeys.FILTER)}>
      {children}
      <Button onClick={onRemoveFilter} color="gray" mt="md">
        {t(i18nKeys.FORM.DELETE_FILTERS)}
      </Button>
    </Drawer>
  );
}
